import { useEffect, useState } from "react";
import { nav, site } from "../lib/content";
import { CloseIcon, MenuIcon } from "./Icons";
import SmartLink from "./SmartLink";

export default function Navbar() {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 8);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  // Prevent the page scrolling behind the open mobile menu.
  useEffect(() => {
    document.body.style.overflow = open ? "hidden" : "";
    return () => {
      document.body.style.overflow = "";
    };
  }, [open]);

  const close = () => setOpen(false);

  return (
    <header
      className={`sticky top-0 z-50 transition-colors duration-200 ${
        scrolled
          ? "border-b border-ink-line bg-white/85 backdrop-blur"
          : "border-b border-transparent bg-transparent"
      }`}
    >
      <nav className="container-page flex h-16 items-center justify-between gap-6" aria-label="Main">
        <SmartLink href="/" onNavigate={close} ariaLabel={`${site.name} home`}>
          <img src="/qostlogo.png" alt={site.name} className="h-8 w-auto" />
        </SmartLink>

        <ul className="hidden items-center gap-8 lg:flex">
          {nav.map((item) => (
            <li key={item.href}>
              <SmartLink
                href={item.href}
                className="text-sm font-medium text-ink-muted transition-colors hover:text-brand-600"
              >
                {item.label}
              </SmartLink>
            </li>
          ))}
        </ul>

        <div className="hidden items-center gap-3 md:flex">
          <SmartLink
            href={site.loginUrl}
            className="text-sm font-semibold text-ink transition-colors hover:text-brand-600"
          >
            Log in
          </SmartLink>
          <SmartLink href={site.registerUrl} className="btn-primary !px-4 !py-2.5">
            Get Started
          </SmartLink>
        </div>

        <button
          type="button"
          className="inline-flex items-center justify-center rounded-lg p-2 text-ink md:hidden"
          aria-expanded={open}
          aria-controls="mobile-menu"
          aria-label={open ? "Close menu" : "Open menu"}
          onClick={() => setOpen((v) => !v)}
        >
          {open ? <CloseIcon /> : <MenuIcon />}
        </button>
      </nav>

      {open && (
        <div id="mobile-menu" className="border-t border-ink-line bg-white md:hidden">
          <div className="container-page flex flex-col gap-1 py-4">
            {nav.map((item) => (
              <SmartLink
                key={item.href}
                href={item.href}
                onNavigate={close}
                className="rounded-lg px-3 py-3 text-base font-medium text-ink hover:bg-ink-soft"
              >
                {item.label}
              </SmartLink>
            ))}
            <SmartLink
              href={site.loginUrl}
              onNavigate={close}
              className="rounded-lg px-3 py-3 text-base font-medium text-ink hover:bg-ink-soft"
            >
              Log in
            </SmartLink>
            <SmartLink href={site.registerUrl} onNavigate={close} className="btn-primary mt-2">
              Get Started
            </SmartLink>
          </div>
        </div>
      )}
    </header>
  );
}
